import * as React from 'react';
const AppContext = React.createContext({});
export const AppProvider = AppContext.Provider;
export const AppConsumer = AppContext.Consumer;
export default function AppConfig({ children, }) {
    return (React.createElement(AppConsumer, null, ({ app }) => {
        if (!app) {
            return null;
        }
        return children(app);
    }));
}
//# sourceMappingURL=index.js.map